'use strict';
(function($){
	/*
	 * Vetology.Tutorials widget
	 *
	 * @description	A widget to display page information
	 *
	 * @options		See description for each option
	 *
	 * @method		See description above each method
	 */
	$.widget(
		'Vetology.Tutorials',
		{
			"options": {
				videos: 0
			},
			/*
			 * Vetology.Tutorials._init
			 *
			 * @description	Initializes the Animal
			 *
			 * @return NULL
			 *
			 */
			"_init": function(){
				var o = this;
				if(typeof window.vetology_tutorial !== "undefined"){
					/*We have tutorial information on page*/
					o.options.config = window.vetology_tutorial;
					if($(".vetology_tutorial_toggle").length === 0){
						$("body").prepend('<div id="floating-tutorial-button" class="floating-tutorial" data-trigger="hover" data-html="html" data-placement="left" data-toggle="popover" data-container="#floating-tutorial-button" data-content="Tutorials"><a href="#" class="vetology_pd vetology_tutorial_toggle hide"><span class="vetology-presentation"></span></a></div>');
					}
                    $("#floating-tutorial-button").popover();
                    if(o.options.config.length > 0){
						o.options.switches = {};
						$.each(o.options.config, function(i, c){
							if(c.videoId != ''){
								o._loadPlayer();
							}
							o.options.switches[c.id] = c;
						});
					}
					o._loadHandlers();
					o._updateHelp();
				}
			},
			/*
			 * Vetology.Tutorials._loadHandlers
			 *
			 * @description	Loads the youtube player API
			 *
			 * @return NULL
			 *
			 */
			"_loadHandlers": function(){
				var o = this;
				$("body").on("click", ".video_help_toggler", function(){
					var el = $(this);
					o._updateHelp(el);
				});
				$("body").on("click", ".vetology_tutorial_toggle", function(){
					var el = $(this);
					o._showHelp();
				});
				$("body").on("click", ".tutorial_item:not(.tutorial_item_active)", function(){
					var el = $(this);
					var tut = o.options.switches[el.data("tutorial")];
					var modal = $(".vetologyModal");
					modal.find(".modal-title").html(tut.title);
					modal.find(".modal-body-content").html(tut.content);
					modal.find(".tutorial_item").removeClass("tutorial_item_active");
					el.addClass("tutorial_item_active");
					if(tut.video_id){
						o.options.player.loadVideoById(tut.video_id);
					}
				});
			},
			/*
			 * Vetology.Tutorials._updateHelp
			 *
			 * @description	Loads the youtube player API
			 *
			 * @return NULL
			 *
			 */
			"_updateHelp": function(el){
				var o = this;
				if(typeof el !== "undefined" && typeof o.options.switches[el.data("video")] !== "undefined"){
					o.options.current = o.options.switches[el.data("video")];
					$(".vetology_tutorial_toggle").removeClass("hide");
				} else {
					o._loadDefault();
				}
			},
			/*
			 * Vetology.Tutorials._showHelp
			 *
			 * @description	Loads the youtube player API
			 *
			 * @return NULL
			 *
			 */
			"_loadDefault": function(){
				var o = this;
				if(typeof o.options.switches != "undefined" && typeof o.options.switches["_default_"] !== "undefined"){
					o.options.current = o.options.switches._default_;
					$(".vetology_tutorial_toggle").removeClass("hide");
				} else {
					delete o.options.current;
					$(".vetology_tutorial_toggle").addClass("hide");
				}
			},
			/*
			 * Vetology.Tutorials._showHelp
			 *
			 * @description	Loads the youtube player API
			 *
			 * @return NULL
			 *
			 */
			"_showHelp": function(el){
				var o = this;
				var current = o.options.current;
				if(typeof current !== "undefined"){
					var other_videos = "";
					if(o.options.config.length > 1){
						other_videos = '<div class="tutorials_list">';
						other_videos += '<h4>Other tutorials on this page</h4>';
						other_videos += '<div>';
						$.each(o.options.switches, function(i, tut){
							var active = i == current.id;
							other_videos += '<a href="#" data-tutorial="' + tut.id + '" class="vetology_pd tutorial_item ' + (active ? "tutorial_item_active" : "") + '">';
							other_videos += '<img src="https://img.youtube.com/vi/' + tut.video_id + '/0.jpg">';
							other_videos += '<span>' + tut.title + '</span>';
							other_videos += '</a>';
						});
						other_videos += '</div>';
						other_videos += '</div>';
					}
					var has_video = typeof current.video_id != "undefined" && current.video_id != "" ? current.video_id : false;
					var content = typeof current.content !== "undefined" && current.content != "" ? o.options.current.content : "";
					content = '<div class="video_trigger">&nbsp;</div><div class="modal-body-content">' + content + "</div>";
					$("body").Vetology("vetologyShowDialog", current.title + '<a href="/doc/contact-us" target="_blank" class="pull-right btn btn-primary btn-xs">Contact</a>', content + other_videos, "info");
					if(has_video){
						var ri = setInterval(
							function(){
								if($(".video_trigger").length === 0 || window.youtube_script){
									clearInterval(ri);
									setTimeout(
										function(){
											if(window.youtube_script && $(".video_trigger").length > 0){
												var video_dom = $(".video_trigger");
												$(".video_trigger").uniqueId();
												o.options.player = new YT.Player(
													video_dom.attr("id"),
													{
														host: 'https://www.youtube.com',
														height: $(".vetologyModal").find(".modal-body").width() * .75,
														width: $(".vetologyModal").find(".modal-body").width() - 20,
														videoId: current.video_id,
														events: {
															'onReady': function(){
																o._playerReady();
															},
															'onStateChange': function(){
																o._playerStateChanged();
															}
														},
														playerVars: {
															rel: 0,
															controls: 0,
															showinfo: 0,
															modestbranding: 1,
														}
													}
												);
											}
										}, 1000
									);
								}
							}, 10
						);
					}
				}
			},
			/*
			 * Vetology.AnimatedAnimals._loadPlayer
			 *
			 * @description	Loads the youtube player API
			 *
			 * @return NULL
			 *
			 */
			"_loadPlayer": function(){
				var o = this;
				if(typeof window.youtube_script == "undefined"){
					window.youtube_script = false;
					var tag = document.createElement('script');
					tag.src = "https://www.youtube.com/iframe_api";
					document.getElementsByTagName('script')[0].parentNode.insertBefore(tag, document.getElementsByTagName('script')[0]);
					window.onYouTubeIframeAPIReady = function(){
						window.youtube_script = true;
					}
				}
			},
			/*
			 * Vetology.AnimatedAnimals._playerReady
			 *
			 * @description	Youtube player ready
			 *
			 * @return NULL
			 *
			 */
			"_playerReady": function(){
				
			},
			/*
			 * Vetology.AnimatedAnimals._playerStateChanged
			 *
			 * @description	Youtube player changed
			 *
			 * @return NULL
			 *
			 */
			"_playerStateChanged": function(){
				
			},
			/*
			 * Vetology.AnimatedAnimals._animator
			 *
			 * @description	Animates an element
			 *
			 * @return NULL
			 *
			 */
			/*
			 * Vetology.AnimatedAnimals._addControls
			 *
			 * @description	Adds control buttons to the animation
			 *
			 * @return NULL
			 *
			 */
		}
	);
})(jQuery);
